import React from 'react';
import Walkthrough from '@fiverr-private/walkthrough/src/Walkthrough';
import { I18nProvider } from '@fiverr-private/i18n-react';
import './index.scss';

const WalkthroughNotableClients = ({ sellerName }) => (
    <I18nProvider>
        {({ i18n }) => (
            <Walkthrough className="walkthrough-notable-clients"
                allowClose
                withAnimation
                nextBtnText={i18n.t('user_page_perseus.notable_clients.gotit')}
                steps={[{
                    element: '.selected-notable-clients',
                    popover: {
                        description: `<div class="popover-description">
                            <div class="m-b-8"><b>${i18n.t('user_page_perseus.notable_clients.title')}</b></div>
                            ${i18n.t('user_page_perseus.notable_clients.tooltip', { sellerName })}
                        </div>`,
                        position: 'right-center'
                    }
                }]}/>
        )}
    </I18nProvider>
);

export default WalkthroughNotableClients;
